import { render } from "./ReactiveRef.vue?vue&type=template&id=a0f6005c"
import script from "./ReactiveRef.vue?vue&type=script&lang=ts"
export * from "./ReactiveRef.vue?vue&type=script&lang=ts"
script.render = render

export default script